import {
  PARTS_HIDDEN_VALUE,
  PARTS_PARAM,
  PREVIEW_PARAM,
  VIDEO_HIDDEN_VALUE,
  VIDEO_PARAM,
} from '../../constants/constants'

/**
 * projectId 遷移用のクエリ文字列を組み立てる純粋関数。
 *
 * プロジェクト作成・選択後の `navigate('?projectId=...')` はクエリ全体を
 * 置き換えるため、プレビューの opt-in（`?preview=on`）・Aeon Fantasy の
 * ビデオ非表示フラグ（`?video=0`）・M1 全パーツ表示フラグ（`?parts=0`）が
 * 遷移で失われると検証・表示制御が継続できない。
 * 現在のクエリから `preview`・`video`・`parts` だけを引き継ぐ
 * （missionId / start などの開始用パラメータは従来どおり破棄する）。
 */
export const buildProjectQuery = (
  projectId: string,
  currentParams: URLSearchParams,
): string => {
  const params = new URLSearchParams({ projectId })
  const preview = currentParams.get(PREVIEW_PARAM)
  if (preview !== null) {
    params.set(PREVIEW_PARAM, preview)
  }
  if (currentParams.get(VIDEO_PARAM) === VIDEO_HIDDEN_VALUE) {
    params.set(VIDEO_PARAM, VIDEO_HIDDEN_VALUE)
  }
  if (currentParams.get(PARTS_PARAM) === PARTS_HIDDEN_VALUE) {
    params.set(PARTS_PARAM, PARTS_HIDDEN_VALUE)
  }
  return `?${params.toString()}`
}
